// Nature of a free (part) line - mirrors the backend PartType enum. The VAT rate is derived from it,
// and REPARATION replaces the old "à réparer" flag (repaired, not bought by the storekeeper).
// sectionTitle heads the type's group of lines in the invoice recap.
export const PART_TYPES = [
  { value: "RECUPERABLE", label: "Récupérable", abbreviation: "REC", vatRate: 0, sectionTitle: "Pièces récupérables" },
  { value: "ADAPTABLE", label: "Adaptable", abbreviation: "ADP", vatRate: 20, sectionTitle: "Pièces adaptables" },
  { value: "ORIGINALE", label: "Originale", abbreviation: "ORG", vatRate: 20, sectionTitle: "Pièces originales" },
  { value: "REPARATION", label: "Réparation", abbreviation: "REP", vatRate: 0, sectionTitle: "Pièces en réparation" },
  { value: "PROGRAMMATION", label: "Programmation", abbreviation: "PRG", vatRate: 20, sectionTitle: "Programmation" },
  { value: "PEINTURE_INGREDIENTS", label: "Peinture et ingrédients", abbreviation: "PI", vatRate: 20, sectionTitle: "Peinture et ingrédients" },
];

const BY_VALUE = Object.fromEntries(PART_TYPES.map((type) => [type.value, type]));

export const getPartTypeLabel = (partType) => BY_VALUE[partType]?.label ?? "—";

export const getPartTypeVatRate = (partType) => BY_VALUE[partType]?.vatRate ?? null;

export const getPartTypeSectionTitle = (partType) => BY_VALUE[partType]?.sectionTitle ?? "Pièces sans type";
